module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBold.7a62698.eot";